import createSpacing from '@material-ui/core/styles/createSpacing';

export default createSpacing(8);
